import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const STORAGE_KEY = 'capital-clues-color-mode';

function readInitialMode() {
  if (typeof window === 'undefined') {
    return 'light';
  }
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') {
    return stored;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

const ColorModeContext = createContext({
  mode: 'light',
  setColorMode: () => {},
  toggleColorMode: () => {},
});

export function ColorModeProvider({ children }) {
  const [mode, setModeState] = useState(readInitialMode);

  const setColorMode = useCallback((next) => {
    setModeState((prev) => {
      const m = typeof next === 'function' ? next(prev) : next;
      if (m === 'light' || m === 'dark') {
        localStorage.setItem(STORAGE_KEY, m);
        return m;
      }
      return prev;
    });
  }, []);

  const toggleColorMode = useCallback(() => {
    setColorMode((prev) => (prev === 'light' ? 'dark' : 'light'));
  }, [setColorMode]);

  const value = useMemo(
    () => ({ mode, setColorMode, toggleColorMode }),
    [mode, setColorMode, toggleColorMode]
  );

  return (
    <ColorModeContext.Provider value={value}>
      {children}
    </ColorModeContext.Provider>
  );
}

export function useColorMode() {
  return useContext(ColorModeContext);
}
